window.Yext = window.Yext || {};
import 'babel-polyfill';
import 'script-loader!node_modules/jquery/dist/jquery.min.js';

import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js';
import { Image } from 'js/components/Image/index.js';
import { LocationHours } from 'js/components/LocationHours/index.js';

Global.init();
GoogleAnalytics.enableAutotracking('yext');

OnReady(() => {
  LocationHours.loadAndRun();
});
